module.exports = __webpack_public_path__ + "img/shopify-limitations-for-e-commerce-img-4.a41ed7f7.jpg";